// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file booking/types/v1/reservation.proto (package booking.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SeatIDs, SeatmapSectionID } from "./order_pb.js";

/**
 * @generated from message booking.types.v1.ReserveBundleRequest
 */
export const ReserveBundleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.ReserveBundleRequest",
  () => [
    { no: 1, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seatmap_section_id", kind: "message", T: SeatmapSectionID, oneof: "section" },
    { no: 4, name: "ga_section_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "section" },
    { no: 5, name: "seats_by_event", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ReserveBundleRequest_Seats} },
  ],
);

/**
 * @generated from message booking.types.v1.ReserveBundleRequest.Seats
 */
export const ReserveBundleRequest_Seats = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.ReserveBundleRequest.Seats",
  () => [
    { no: 1, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "seating" },
    { no: 2, name: "seat_ids", kind: "message", T: SeatIDs, oneof: "seating" },
  ],
  {localName: "ReserveBundleRequest_Seats"},
);

/**
 * @generated from message booking.types.v1.ReserveBundleResponse
 */
export const ReserveBundleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.ReserveBundleResponse",
  () => [
    { no: 1, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking.types.v1.CancelBundleRequest
 */
export const CancelBundleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.CancelBundleRequest",
  () => [
    { no: 1, name: "reservation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seatmap_section_id", kind: "message", T: SeatmapSectionID, oneof: "section" },
    { no: 4, name: "ga_section_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "section" },
    { no: 5, name: "seats_by_event", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: CancelBundleRequest_Seats} },
  ],
);

/**
 * @generated from message booking.types.v1.CancelBundleRequest.Seats
 */
export const CancelBundleRequest_Seats = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.CancelBundleRequest.Seats",
  () => [
    { no: 1, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "seating" },
    { no: 2, name: "seat_ids", kind: "message", T: SeatIDs, oneof: "seating" },
  ],
  {localName: "CancelBundleRequest_Seats"},
);

/**
 * @generated from message booking.types.v1.CancelBundleResponse
 */
export const CancelBundleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.CancelBundleResponse",
  [],
);

